/**
 * Forte Plus — vásárlói vélemények: folyamatos, automatikus vízszintes futósáv
 * (sections/ep-testimonials.liquid).
 *
 * A sáv natív görgetés, a kártyákat egyszer megduplázzuk, és a görgetés a felénél visszaugrik —
 * így a mozgás végtelennek látszik, a látogató mégis bármikor húzhatja kézzel is. Ha a JS nem fut
 * le, a vélemények ugyanúgy olvashatók és görgethetők maradnak.
 */
(() => {
  class EpTestimonialsComponent extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound === 'true') return;
      this.dataset.bound = 'true';

      this.track = this.querySelector('[data-testi-track]');
      if (!this.track) return;

      this.speed = Number(this.dataset.speed) || 0; // px / másodperc, 0 = áll
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.pointerPaused = false;
      this.carry = 0;
      this.half = 0;

      this.duplicateCards();

      this.addEventListener('pointerenter', this.pause);
      this.addEventListener('pointerleave', this.resume);
      this.addEventListener('focusin', this.pause);
      this.addEventListener('focusout', this.resume);
      this.track.addEventListener('pointerdown', this.pause);
      window.addEventListener('pointerup', this.resume);
      this.track.addEventListener('scroll', this.wrap, { passive: true });
      document.addEventListener('visibilitychange', this.onVisibility);
      this.reducedMotion.addEventListener('change', this.onMotionPreference);

      // Régi WebView-kban (a forgalmunk 80%-a a Facebook appon belüli böngésző) nincs mindig
      // ResizeObserver — enélkül a konstruktor ReferenceError-t dob, és a szalag el sem indul.
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.measure());
        this.resizeObserver.observe(this.track);
      }

      this.measure();
      this.start();
    }

    disconnectedCallback() {
      this.stop();
      this.resizeObserver?.disconnect();
      window.removeEventListener('pointerup', this.resume);
      document.removeEventListener('visibilitychange', this.onVisibility);
      this.reducedMotion.removeEventListener('change', this.onMotionPreference);
    }

    /** Egy másolat a kártyákból, hogy a sáv sosem érjen véget. */
    duplicateCards() {
      const cards = Array.from(this.track.children);
      if (cards.length < 2) return;
      for (const card of cards) {
        const clone = card.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.dataset.clone = 'true';
        this.track.append(clone);
      }
    }

    measure() {
      this.half = this.track.scrollWidth / 2;
    }

    /** A felénél visszaugrunk — kézi húzásnál mindkét irányban. */
    wrap = () => {
      if (this.half <= 0) return;
      if (this.track.scrollLeft >= this.half) this.track.scrollLeft -= this.half;
      else if (this.track.scrollLeft <= 0) this.track.scrollLeft += this.half;
    };

    pause = () => {
      this.pointerPaused = true;
    };

    resume = () => {
      this.pointerPaused = false;
    };

    onVisibility = () => {
      if (document.hidden) this.stop();
      else this.start();
    };

    onMotionPreference = () => {
      this.stop();
      this.start();
    };

    start() {
      if (this.frame || !this.speed || this.reducedMotion.matches) return;
      if (this.track.scrollWidth <= this.track.clientWidth + 1) return;
      this.last = 0;
      this.frame = requestAnimationFrame(this.tick);
    }

    stop() {
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = null;
    }

    tick = (timestamp) => {
      const elapsed = this.last ? (timestamp - this.last) / 1000 : 0;
      this.last = timestamp;

      // egész pixelenként lépünk, a maradékot visszük tovább: lassú sebességnél sem áll meg
      if (!this.pointerPaused && elapsed > 0 && elapsed < 0.5) {
        this.carry += this.speed * elapsed;
        const step = Math.floor(this.carry);
        if (step >= 1) {
          this.carry -= step;
          this.track.scrollLeft += step;
          this.wrap(); // itt, nem csak a scroll eseményben: az aszinkron, ez nem csúszhat túl
        }
      }

      this.frame = requestAnimationFrame(this.tick);
    };
  }

  if (!customElements.get('ep-testimonials-component')) {
    customElements.define('ep-testimonials-component', EpTestimonialsComponent);
  }
})();
